var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"margin":"auto"},attrs:{"width":"50%"}},[_c('v-toolbar',{attrs:{"color":"primary"}},[_vm._v(" Устройства ")]),_c('v-card-text',[_c('v-simple-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }